import { render, staticRenderFns } from "./CreateProjectModal.vue?vue&type=template&id=3583afe5&scoped=true&"
import script from "./CreateProjectModal.vue?vue&type=script&lang=js&"
export * from "./CreateProjectModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateProjectModal.vue?vue&type=style&index=0&id=3583afe5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3583afe5",
  null
  
)

export default component.exports